import React, { Component } from 'react';
import { IOffer } from '../../Models';
import { AddOrDeleteOffer } from './AddOrDeleteOffer';
import { DatePublish } from '../DatePublish';

interface OfferItemProps {
    homepageUrl: string;
    offer: IOffer;
    offerDetailPageName: string;
    dictBelgium: string;
    dictForeign: string;
    dictThe: string;
    dictOfferDelete: string;
    dictPreselectActiris: string;
    dictContractType: string;
    dictOfferSave: string;
    dictSelectExplanation: string;
    dictSelectActirisDescription: string;
    onClickBasketOffer: (offer: IOffer) => void;
    onClickOfferTitle: (offerId: string) => void | undefined;
    dictRef: string;
    language: string;

    dictToday: string;
    dictEdited: string;
    dictPublished: string;
    dictYesterday: string;
    dictDaysAgo: string;
    dictWeeksAgo: string;
    dictWeekAgo: string;
    dictMonthsAgo: string;
    dictMonthAgo: string;
    dictYearsAgo: string;
    dictYearAgo: string;
}

interface OfferItemState {
    displayEmployerImage: boolean;
}

export class OfferItem extends Component<OfferItemProps, OfferItemState> {
    constructor(props: OfferItemProps) {
        super(props);

        this.state = {
            displayEmployerImage: true,
        };
    }

    onClickOfferBasket = () => {
        this.props.onClickBasketOffer(this.props.offer);
    };

    onClickOfferTitle = () => {
        this.props.onClickOfferTitle(this.props.offer.reference);
    };

    HandleNoImageForOffer = () => {
        this.setState({ displayEmployerImage: false });
    };

    dureeContratOuTypecontrat(): string {
        return [
            'DUT',
            'INT',
            'NOR',
            'IND',
            'CIP',
            'EURODYSSEE',
            'STAGE SPEP',
            'STAGE ETRANGER',
            'FPI',
            'JE',
        ].includes(this.props.offer.typeContrat)
            ? this.props.offer.typeContratLibelle
            : this.props.offer.typeContrat === 'ACT'
              ? this.props.offer.dureeContratLibelle +
                ' - ' +
                this.props.offer.typeContratLibelle
              : this.props.offer.dureeContratLibelle;
    }

    render() {
        const cssId =
            sessionStorage.currentOfferId &&
            sessionStorage.currentOfferId == this.props.offer.reference
                ? { id: 'currentOffer' }
                : {};

        const sourceLogo = `https://my.actiris.brussels/Repository/Tiers/${this.props.offer.numeroEntreprise}/${this.props.language}.png`;

        return (
            <article
                {...cssId}
                data-gtmref={this.props.offer.reference}
                data-gtmtype={this.props.offer.typeOffer}
                className={
                    'gtm-joboffer tile tile--job' +
                    (this.props.offer.typeOffer === 'Select'
                        ? ' select-actiris'
                        : '')
                }
            >
                <div className="image-content">
                    <img
                        onError={(event) =>
                            ((
                                event.target as HTMLTextAreaElement
                            ).style.display = 'none')
                        }
                        src={sourceLogo}
                        alt={
                            this.props.offer.employeur &&
                            this.props.language === 'fr'
                                ? this.props.offer.employeur.nomFr
                                : this.props.offer.employeur &&
                                  this.props.offer.employeur.nomNl
                        }
                    />
                </div>
                <div className="left-content">
                    <a
                        href={
                            this.props.homepageUrl +
                            this.props.offerDetailPageName +
                            '/?reference=' +
                            this.props.offer.reference +
                            '&type=' +
                            this.props.offer.typeOffer
                        }
                        onClick={this.onClickOfferTitle}
                    >
                        <h3
                            className="title"
                            dangerouslySetInnerHTML={{
                                __html:
                                    this.props.language === 'fr'
                                        ? this.props.offer.titreFr ||
                                          this.props.offer.titreNl
                                        : this.props.offer.titreNl ||
                                          this.props.offer.titreFr,
                            }}
                        ></h3>
                    </a>
                    <div className="under-title">
                        {this.props.offer.reference && (
                            <span>
                                {this.props.dictRef}{' '}
                                {this.props.offer.reference}
                            </span>
                        )}
                        {(this.props.offer.communeFr ||
                            this.props.offer.communeNl) && (
                            <span>
                                {' '}
                                -{' '}
                                {this.props.language === 'fr'
                                    ? this.props.offer.communeFr ||
                                      this.props.offer.communeNl
                                    : this.props.offer.communeNl ||
                                      this.props.offer.communeFr}
                            </span>
                        )}
                        {
                            <div>
                                {this.props.dictContractType} :{' '}
                                {this.props.offer.typeContratLibelle}
                            </div>
                        }
                    </div>
                    <div className="state">
                        {this.props.offer.typeOffer &&
                            this.props.offer.typeOffer === 'Select' && (
                                <span>{this.props.dictPreselectActiris} </span>
                            )}
                        {this.props.offer.typeOffer &&
                            this.props.offer.employeur &&
                            this.props.offer.typeOffer !== 'Select' && (
                                <span>
                                    {this.props.language === 'fr'
                                        ? this.props.offer.employeur.nomFr !=
                                          null
                                            ? this.props.offer.employeur.nomFr
                                            : this.props.offer.employeur.nomNl
                                        : this.props.offer.employeur.nomNl !=
                                            null
                                          ? this.props.offer.employeur.nomNl
                                          : this.props.offer.employeur
                                                .nomFr}{' '}
                                </span>
                            )}
                        (
                        <DatePublish
                            editionDate={this.props.offer.dateModification}
                            creationDate={this.props.offer.dateCreation}
                            dictToday={this.props.dictToday}
                            dictEdited={this.props.dictEdited}
                            dictPublished={this.props.dictPublished}
                            dictYesterday={this.props.dictYesterday}
                            dictDaysAgo={this.props.dictDaysAgo}
                            dictWeeksAgo={this.props.dictWeeksAgo}
                            dictWeekAgo={this.props.dictWeekAgo}
                            dictMonthsAgo={this.props.dictMonthsAgo}
                            dictMonthAgo={this.props.dictMonthAgo}
                            dictYearsAgo={this.props.dictYearsAgo}
                            dictYearAgo={this.props.dictYearAgo}
                        />
                        )
                    </div>
                </div>
                <div className="right-content">
                    {(this.props.offer.typeOffer == 'Select' ||
                        this.props.offer.typeOffer == 'DirectOnline' ||
                        this.props.offer.typeOffer == 'Hrxml') && (
                        <AddOrDeleteOffer
                            className={
                                this.props.offer.isSaved ? ' active' : ''
                            }
                            label={
                                this.props.offer.isSaved
                                    ? this.props.dictOfferDelete
                                    : this.props.dictOfferSave
                            }
                            onClick={this.onClickOfferBasket}
                        />
                    )}
                </div>
            </article>
        );
    }
}
